import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { ALTAEMPRESA, ALTAPARTICULAR } from "../../../constants/routes";
import { SelectMulti } from "../../../components/others/SelectMulti";
import StyledWrapper from "./style";
import AddCompany from "../addCompany/AddCompany";
import AddParticularPatient from "../addParticularPatient/AddParticularPatient";
import AddBranchOffice from "../addBranchOffice/addBranchOffice";

const TypeOptions: { [key: string]: JSX.Element } = {
  "Empresa": <AddCompany />,
  "Particular": <AddParticularPatient />,
  "": <></>
}

export default function AddTypes() {

  const {
    formState: { errors },
    register,
    watch,
  } = useForm<{ type: string }>({ mode: "all" })

  const tipoWatch = watch('type') || ""

  const mappedOptions = Object.keys(TypeOptions).map(item => ({
    name: item,
    value: item
  }))

  return (
    <div className="register-form">

      <h5 className="title">
        Creación de cuenta
      </h5>
      <p>
        Seleciona el tipo de cuenta que desees crear
      </p>
      <div className="mt-10 add-selector">
        <Link to={"Empresa"} style={{ backgroundColor: "red", color: "white" }}>
          <span style={{ display: "inline-flex", alignItems: "center", marginRight: "8px"}}>
            {/* Business Account SVG */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="7" width="18" height="13" rx="2" />
              <path d="M16 3v4" />
              <path d="M8 3v4" />
              <path d="M3 11h18" />
            </svg>
          </span>
          Empresa
        </Link>
        <Link title="Obligatorio contar con presupuesto gestionado en el Cel. 3513700999" to={"Paciente-particular"} style={{ backgroundColor: "blue", color: "white" }}>
          <span style={{ display: "inline-flex", alignItems: "center", marginRight: "8px" }}>
            {/* Personal Account SVG */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-3.3 3.6-6 8-6s8 2.7 8 6" />
            </svg>
          </span>
          Particular
        </Link>
        {/* <SelectMulti
          fieldName="type"
          styles={`w-full rounded-md h-12 mb-${!tipoWatch ? '0' : '6'}`}
          register={register}
          label={"Tipo"}
          required={true}
          error={errors?.["type"]}
          options={mappedOptions}
        >
          {TypeOptions[tipoWatch]}
        </SelectMulti> */}
      </div>

    </div>
  );
}
